export default __webpack_public_path__ + "static/media/17.b0954760.png";